/* eslint
    no-empty-function: "warn",
    dot-notation: "off"
*/

import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';
import easyfyToaster, { MessageSeverity } from '@shared/easyfy.toaster';
import formService from '@inlineServices/form.service';

namespace Meds.Modules {
  @invoke
  class Footer {

    onInit() {
      globalEvent({
        type: 'submit',
        event: {
          action: 'subscribe-newsletter',
          callback: Footer.subscribeToNewsletter
        }
      });
    }

    static subscribeToNewsletter = async (e) => {
      e.preventDefault();
      e.stopPropagation();

      const element: HTMLFormElement = e.target as HTMLFormElement;
      const data: FormData = new FormData(element);
      const dataMessageContainer = element.attributes['data-message']?.value;
      const messageContainer = element.querySelector(
        `[data-container="${dataMessageContainer}"]`
      ) as HTMLElement;
      const subscribeNewsletter = document.getElementById(
        'subscribeNewsletter'
      ) as HTMLButtonElement;
      const subscribeText = subscribeNewsletter.innerHTML;
      subscribeNewsletter.disabled = true;
      subscribeNewsletter.innerHTML = '<div class="loader" role="status" aria-live="polite" aria-label="Laddar"></div>';

      formService
        .PostForm(element.attributes['action']?.value, data)
        .then((response) => {
          if (messageContainer) {
            easyfyToaster.toaster(
              response.data.success
                ? MessageSeverity.success
                : MessageSeverity.error,
              response.data.message,
              messageContainer
            );
          } else {
            easyfyToaster.toaster(
              response.data.success
                ? MessageSeverity.success
                : MessageSeverity.error,
              response.data.message
            );
          }
          subscribeNewsletter.disabled = false;
          subscribeNewsletter.innerHTML = subscribeText;
          if (response.data.success) {
            element.reset();
          }
        });
    };
  }
}
